import { $ as q, $$ as qa, isShown as vis, esc, nf } from './_helpers'

const { __, sprintf } = wp.i18n

// Live summary — READ ONLY.
// Independent of the form script: it modifies no field, intercepts no event
// and does not touch the sending. It re-reads the page after each interaction.
export const initRecap = () => {
  try {
    const txt = (el) => (el ? el.textContent.trim() : '')
    const val = (el) => (el ? String(el.value).trim() : '')
    const opt = (el) => (el && el.value ? el.selectedOptions[0].textContent.trim() : '')
    const body = q('#rcBody'),
      state = q('#rcState'),
      box = q('#rcBox')
    if (!body) return

    // Tablet / mobile: summary folded by default; desktop: always open
    const mq = matchMedia('(max-width: 991.98px)')
    const syncOpen = () => {
      box.open = !mq.matches
    }
    syncOpen()
    mq.addEventListener('change', syncOpen)
    box.querySelector('summary').addEventListener('click', (e) => {
      if (!mq.matches) e.preventDefault()
    })

    let last = ''
    function render() {
      const selT = q('#products .tile.on')
      const type = txt(selT),
        family = selT ? txt(selT.closest('.pgroup').querySelector('.pgroup-title')) : ''
      const title = val(q('[data-k="product.title"]'))
      const qty = qa('.qty')
        .map((i) => +i.value)
        .filter(Boolean)

      let versions = 0
      if (q('#multiVersions')?.checked) {
        versions =
          q('input[name=vmode]:checked')?.value === 'equal'
            ? +val(q('#vCount')) || 0
            : qa('#vRows .pt-quote__row').length
      }

      const rows = []
      const add = (label, value, sub = '') => rows.push([label, value, sub])

      const w = val(q('#fw')),
        h = val(q('#fh'))
      add(__('Finished format', 'vn'), w && h ? `${w} × ${h} mm` : '')
      if (vis(q('#openBox'))) {
        const ow = val(q('[data-k="format.openWidth"]')),
          oh = val(q('[data-k="format.openHeight"]'))
        add(__('Open format', 'vn'), ow && oh ? `${ow} × ${oh} mm` : '')
      }
      if (vis(q('#pagesBox'))) {
        const p = val(q('#pagesInterior'))
        /* translators: %s: number of pages */
        add(__('Pagination', 'vn'), p ? sprintf(__('%s pages', 'vn'), p) : '', p ? opt(q('#coverType')) : '')
      }

      const els = qa('#elements .element')
      if (els.length) {
        els.forEach((el) => {
          const g = opt(q('[data-e=grammage]', el))
          const t = opt(q('[data-e=type]', el))
          const recto = opt(q('[data-e=recto]', el)),
            verso = q('[data-e=verso]', el)?.value
          /* translators: %s: printing */
          const print =
            sprintf(__('Front %s', 'vn'), recto) +
            (verso && verso !== 'aucune'
              ? ' / ' + sprintf(__('back %s', 'vn'), opt(q('[data-e=verso]', el)))
              : '')
          const ef = []
          const lam = q('[data-e=lamination]', el),
            sv = q('[data-e=spotVarnish]', el)
          if (lam && lam.value) ef.push(opt(lam) + ' ' + opt(q('[data-e=laminationSides]', el)))
          if (sv && sv.value) ef.push(sprintf(__('Spot varnish %s', 'vn'), opt(sv)))
          if (q('[data-e=hotFoil]', el)?.checked) ef.push(__('Hot foil stamping', 'vn'))
          if (q('[data-e=scoring]', el)?.checked) ef.push(__('Scoring', 'vn'))
          add(
            els.length > 1 ? el.dataset.name : __('Paper', 'vn'),
            g ? `${g} ${t}` : '',
            [g ? print : '', ef.join(', ')].filter(Boolean).join(' — ')
          )
        })
      } else {
        add(__('Paper', 'vn'), '')
      }
      if (q('[data-k="certified"]')?.checked) add(__('Certification', 'vn'), 'PEFC / FSC')

      const fin = []
      if (vis(q('#bindingBox')) && val(q('#binding'))) fin.push(opt(q('#binding')))
      if (vis(q('#foldBox')) && val(q('[data-k="finishing.fold"]')))
        fin.push(opt(q('[data-k="finishing.fold"]')))
      if (q('#cutting')?.checked) fin.push(__('Die-cutting', 'vn'))
      if (vis(q('#flatBox')) && q('[data-k="finishing.flat"]')?.checked)
        fin.push(__('Delivered flat', 'vn'))
      if (vis(q('#cornersBox')) && q('[data-k="finishing.corners"]')?.checked)
        fin.push(__('Rounded corners', 'vn'))
      add(__('Shaping', 'vn'), fin.join(', '))

      add(__('Packaging', 'vn'), val(q('[data-k="delivery.packagingNote"]')))

      if (q('input[name=dmode]:checked')?.value === 'pickup') {
        add(__('Delivery', 'vn'), __('Collection from the printing works', 'vn'))
      } else {
        const pts = qa('.point')
          .map((r) => [val(q('.pcp', r)), val(q('.pcity', r))].filter(Boolean).join(' '))
          .filter(Boolean)
        add(
          __('Delivery', 'vn'),
          /* translators: %d: number of delivery points */
          pts.length > 1 ? sprintf(__('%d points', 'vn'), pts.length) : pts[0] || '',
          pts.length > 1 ? pts.join(', ') : ''
        )
      }
      const d = val(q('#ddate'))
      add(
        __('Requested date', 'vn'),
        d
          ? new Date(d + 'T12:00').toLocaleDateString('fr-FR', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
            })
          : ''
      )

      const filled = rows.filter((r) => r[1]).length + (type ? 1 : 0) + (qty.length ? 1 : 0)
      const total = rows.length + 2

      let html = ''
      if (!type && !qty.length && filled === 0) {
        html = `<p class="rc-empty">${esc(__('Your choices will appear here as you go through the steps.', 'vn'))}</p>`
      } else {
        html += `<div class="rc-product">${esc(type || __('Product to be chosen', 'vn'))}</div>`
        html += `<div class="rc-sub">${esc([family, title].filter(Boolean).join(' — ') || ' ')}</div>`
        html +=
          '<div class="rc-figure">' +
          (qty.length
            ? `<b>${qty.map(nf).join(' / ')}</b><span>${esc(__('copies', 'vn'))}</span>`
            : `<span>${esc(__('Quantity to be specified', 'vn'))}</span>`) +
          /* translators: %d: number of versions */
          (versions > 1 ? `<span class="rc-chip">${esc(sprintf(__('%d versions', 'vn'), versions))}</span>` : '') +
          '</div>'
        html +=
          '<dl class="rc-list">' +
          rows
            .map(
              ([l, v, s]) =>
                `<dt>${esc(l)}</dt><dd class="${v ? '' : 'empty'}">${v ? esc(v) : '—'}${s ? `<small>${esc(s)}</small>` : ''}</dd>`
            )
            .join('') +
          '</dl>'
      }
      if (html !== last) {
        body.innerHTML = html
        if (last) {
          body.classList.remove('rc-flash')
          void body.offsetWidth
          body.classList.add('rc-flash')
        }
        last = html
      }
      /* translators: 1: number of filled items, 2: total */
      state.textContent = sprintf(__('%1$d / %2$d filled in', 'vn'), filled, total)
    }

    let t
    const schedule = () => {
      clearTimeout(t)
      t = setTimeout(render, 30)
    }
    ;['input', 'change', 'click'].forEach((ev) => document.addEventListener(ev, schedule, true))
    render()
  } catch (e) {
    console.warn('Quote summary unavailable', e) // eslint-disable-line no-console
  }
}
